import React, { useState, useRef, useEffect } from "react";
import ForeignPersonal from "./ForeignPersonal";
import AssociatedCorporation from "./AssociatedCorporation";
import AssociatedPatient from "./AssociatedPatient";
import AddressAbroad from "./AddressAbroad";
import BankDetailsAbroad from "./BankDetailsAbroad";
import Authorities from "./Authorities";
import DepositAccount from "./DepositAccount";
import FormWrapper from "./FormWrapper";
import SubMenu from "../../../components/templates/SubMenu";
import Spacer from "../../../components/layouts/Spacer";
import ContentSider from "../../../components/templates/ContentSider";
import { Layout } from "antd";
import PropTypes from "prop-types";
import {
  AuditOutlined,
  CarryOutOutlined,
  ExceptionOutlined,
  GlobalOutlined,
} from "@ant-design/icons";
import VisibilitySensor from "react-visibility-sensor";
const { Content } = Layout;

const items = [
  {
    name: "personalDetails",
    category: "employees",
    icon: <AuditOutlined />,
  },
  {
    name: "associatedPatient",
    category: "employees",
    icon: <AuditOutlined />,
  },
  {
    name: "associatedCorporation",
    category: "employees",
    icon: <CarryOutOutlined />,
  },
  {
    name: "authorities",
    category: "employees",
    icon: <CarryOutOutlined />,
  },
  {
    name: "deposit_acccount",
    category: "employees",
    icon: <CarryOutOutlined />,
  },
  {
    name: "addressAbroad",
    category: "employees",
    icon: <GlobalOutlined />,
  },
  {
    name: "bankDetailsAbroad",
    category: "employees",
    icon: <ExceptionOutlined />,
  },
];

const Foreign = (props) => {
  const {
    mode,
    onSubmit,
    onFinishFailed,
    onDecline,
    saveLoading,
    activeEmployee,
    changedValues,
    changedItems,
  } = props;
  const [selectedKeys, setSelectedKeys] = useState("personalDetails");
  const [visibleKeys, setVisibleKeys] = useState([
    { itemKey: "personalDetails", weight: 1 },
  ]);
  const [scrollEnabled, setScrollEnabled] = useState(true);

  useEffect(() => {
    visibleKeys.sort((a, b) => a.weight - b.weight);
    if (scrollEnabled) {
      setSelectedKeys(visibleKeys[0] ? [visibleKeys[0].itemKey] : []);
    }
  }, [visibleKeys, scrollEnabled]);

  const personalDetails = useRef();
  const associatedPatient = useRef();
  const associatedCorporation = useRef();
  const addressAbroad = useRef();
  const bankDetailsAbroad = useRef();
  const authorities = useRef();
  const deposit_acccount = useRef();

  let refs = {
    personalDetails: personalDetails,
    associatedPatient: associatedPatient,
    associatedCorporation: associatedCorporation,
    authorities: authorities,
    deposit_acccount: deposit_acccount,
    addressAbroad: addressAbroad,
    bankDetailsAbroad: bankDetailsAbroad,
  };

  const onMenuSelect = ({ key }) => {
    if ([key] && refs[key].current) {
      setScrollEnabled(false);
      refs[key].current.scrollIntoView({ behavior: "smooth" });
      setTimeout(() => setScrollEnabled(true), 1000);
    }
    setSelectedKeys([key]);
  };

  const onVisiblityChanged = (itemKey, weight) => (isVisible) => {
    if (isVisible) {
      setVisibleKeys([...visibleKeys, { itemKey, weight }]);
    } else {
      setVisibleKeys([
        ...visibleKeys.filter((item) => item.itemKey !== itemKey),
      ]);
    }
  };

  return (
    <Layout
      style={{
        background: "transparent",
        height: "100%",
        display: "flex",
        flexDirection: "row",
      }}
    >
      <Spacer horizontal={true} />
      <ContentSider width={250}>
        <SubMenu
          onMenuSelect={onMenuSelect}
          items={items}
          selectedKeys={selectedKeys}
        />
      </ContentSider>
      <Content>
        <FormWrapper
          mode={mode}
          onSubmit={onSubmit}
          onFinishFailed={onFinishFailed}
          hideDelete={true}
          onDecline={onDecline}
          saveLoading={saveLoading}
          padding={true}
        >
          <VisibilitySensor
            scrollThrottle={200}
            offset={{ top: 220 }}
            scrollCheck
            partialVisibility={true}
            onChange={onVisiblityChanged("personalDetails", 1)}
          >
            <ForeignPersonal ref={personalDetails} />
          </VisibilitySensor>
          <VisibilitySensor
            scrollThrottle={200}
            offset={{ top: 220 }}
            scrollCheck
            partialVisibility={true}
            onChange={onVisiblityChanged("associatedPatient", 2)}
          >
            <AssociatedPatient
              ref={associatedPatient}
              activeEmployee={activeEmployee}
            />
          </VisibilitySensor>

          <VisibilitySensor
            scrollThrottle={200}
            offset={{ top: 220 }}
            scrollCheck
            partialVisibility={true}
            onChange={onVisiblityChanged("associatedCorporation", 2)}
          >
            <AssociatedCorporation
              ref={associatedCorporation}
              activeEmployee={activeEmployee}
              changedValues={changedValues}
              changedItems={changedItems}
            />
          </VisibilitySensor>
          <VisibilitySensor
            scrollThrottle={200}
            offset={{ top: 220 }}
            scrollCheck
            partialVisibility={true}
            onChange={onVisiblityChanged("authorities", 3)}
          >
            <Authorities ref={authorities} activeEmployee={activeEmployee} />
          </VisibilitySensor>
          <VisibilitySensor
            scrollThrottle={200}
            offset={{ top: 220 }}
            scrollCheck
            partialVisibility={true}
            onChange={onVisiblityChanged("deposit_acccount", 4)}
          >
            <DepositAccount ref={deposit_acccount} />
          </VisibilitySensor>
          <VisibilitySensor
            scrollThrottle={200}
            offset={{ top: 280 }}
            scrollCheck
            partialVisibility={true}
            onChange={onVisiblityChanged("addressAbroad", 5)}
          >
            <AddressAbroad ref={addressAbroad} />
          </VisibilitySensor>
          <VisibilitySensor
            scrollThrottle={200}
            offset={{ top: 240 }}
            scrollCheck
            partialVisibility={true}
            onChange={onVisiblityChanged("bankDetailsAbroad", 6)}
          >
            <BankDetailsAbroad ref={bankDetailsAbroad} />
          </VisibilitySensor>
        </FormWrapper>
      </Content>
    </Layout>
  );
};

Foreign.propTypes = {
  mode: PropTypes.string,
  onFinish: PropTypes.func,
  onFinishFailed: PropTypes.func,
  onDecline: PropTypes.func,
  addImage: PropTypes.func,
  saveLoading: PropTypes.bool,
};

export default Foreign;
